app.controller("EmployeeReviewDocumentsController", [
    "$scope", "$stateParams", "StaticData", "DocumentsService", "AuthService", "Socket", "$state", "toastr", "usSpinnerService",
    function ($scope, $stateParams, StaticData, DocumentsService, AuthService, Socket, $state, toastr, usSpinnerService) {
        $scope.documents = [];
        $scope.totalItems = 0;
        $scope.format = "dd-MM-yyyy";
        $scope.documentTypes = {
            'INNER': [],
            'STUDENT_INNER': [],
            'OUTER': [],
            'OUTGOING': [],
        };

        var socket = new Socket("/documents");

        socket.on('review', function (document) {
            $scope.documents.unshift(document);
            $scope.totalItems = $scope.documents.length;
        });

        socket.on('reviewed', function () {
            $scope.loadPage();
        });

        StaticData.getItemsByKey("document_types").then(function (types) {
            $scope.documentTypesMap = _.keyBy(types, '_id');
        });

        function getDocumentTypes() {
            usSpinnerService.spin("root");
            DocumentsService.typeList({ admin: true }).then(function (data) {
                data.forEach(function (type) {
                    $scope.documentTypes[type.parentId].push(type)
                });

                usSpinnerService.stop("root");
            }).catch(function () {
                usSpinnerService.spin("root");
                toastr.error('', 'დაფიქსირდა შეცდომა');
            });
        }

        getDocumentTypes();

        $scope.loadPage = function () {
            usSpinnerService.spin("root");

            DocumentsService.reviewList().then(function (res) {
                $scope.documents = res.data;
                $scope.totalItems = $scope.documents.length;
                usSpinnerService.stop("root");
            });
        };

        $scope.loadPage();

        $scope.open = function (actionType, docId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $state.go('employee.documents.view', { actionType: actionType, documentId: docId, returnUrl: window.location.href })
        };

        $scope.select = function (docId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
        };

        $scope.download = function (url, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open(url);
        };
    }
]);
